import React, { useEffect, useRef, useContext, useState } from "react";
import { useSelector, shallowEqual } from "react-redux";
import { Form, Col, Button, Tab, Row, Nav } from "react-bootstrap";
import Portal from "../../poral";
import { FiX } from "react-icons/fi";
import vnegocio from "../../../validator/negocio";
import Danger from "../../Alertas/Danger";
import DireccionState from "../../../context/Direccion/direccionState";
import ContribuyenteContext from "../../../context/Contribuyente/contribuyenteContext";
import useValidation from "../../../Hooks/UseValidation";
import { Dropdown } from "semantic-ui-react";
import NegociosContext from "../../../context/Negocios/negociosContext";
import Direccion from "../../Direccion";
const STATE_INICIAL = {
  razonsocial: "",
  rfc: "",
  tipocomercio: "",
  ContribuyenteId: "",
};
const AgregarNegocio = ({ title, open, setOpen, usuario, token }) => {
  //Validadores
  const {
    valores,
    errores,
    handleChange,
    handleBlur,
    handleSubmit,
  } = useValidation(STATE_INICIAL, vnegocio, formRegister);

  //Asignamos la id del negocio para poder guardarlo en el sistema
  const [nid, setNid] = useState(null);
  const [tipo, setTipo] = useState(true);
  const contribuyenteContext = useContext(ContribuyenteContext);
  const negocioContext = useContext(NegociosContext);
  const { palettes } = useSelector(
    (state) => ({
      palettes: state.palettes,
    }),
    shallowEqual
  );
  let { background } = {
    ...palettes,
  };

  const { contribuyentes, obtenerContribuyentes } = contribuyenteContext;
  const { crearNegocio, negocio } = negocioContext;

  useEffect(() => {
    obtenerContribuyentes(usuario.id, token);
  }, []);

  const modalRef = useRef(null);
  const hide = () => {
    setOpen(false);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!modalRef || !modalRef.current) return false;
      console.log(modalRef.current.contains(event.target));
      if (!open || modalRef.current.contains(event.target)) {
        return false;
      }
      setOpen(!open);
    };
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open, modalRef]);

  //Formulario para el registro
  async function formRegister() {
    crearNegocio(usuario.id, token, valores);
  }

  //Obtenemos la id del negocio guardado para asignarla a la dirección
  useEffect(() => {
    if (!negocio.code === 200) {
      setNid(null);
    } else {
      setNid(negocio.nid);
    }
  });

  return (
    <>
      {open && (
        <Portal selector="#portal">
          <div className="modal-backdrop fade-in"></div>
          <div
            className={`modal show ${background === "dark" ? "dark-mode" : ""}`}
            data-background={background}
          >
            <div
              className="relative min-w-sm w-auto mx-auto lg:max-w-5xl"
              ref={modalRef}
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h3 className="text-xl font-semibold">{title}</h3>
                  <button
                    className="modal-close btn btn-transparent"
                    onClick={hide}
                  >
                    <FiX size={18} className="stroke-current" />
                  </button>
                </div>
                <div className="relative p-4 flex-auto">
                  <DireccionState>
                    <Formulario
                      contribuyentes={contribuyentes}
                      handleChange={handleChange}
                      handleSubmit={handleSubmit}
                      handleBlur={handleBlur}
                      valores={valores}
                      errores={errores}
                      nid={nid}
                      setNid={setNid}
                      token={token}
                      userid={usuario.id}
                      tipo={tipo}
                      setTipo={setTipo}
                      //   cid={cid}
                      //   setCid={setCid}
                      //   actualizar={actualizar}
                      //   token={token}
                      //   userid={usuario.id}
                    />
                  </DireccionState>
                </div>
              </div>
            </div>
          </div>
        </Portal>
      )}
    </>
  );
};

function Formulario(props) {
  const {
    contribuyentes,
    handleSubmit,
    handleChange,
    handleBlur,
    valores,
    errores,
    nid,
    setNid,
    token,
    userid,
    tipo = { tipo },
    setTipo = { setTipo },
  } = props;
  const { rfc, razonsocial, tipocomercio } = valores;

  const [contId, setContribuyenteId] = useState({
    ContribuyenteId: "",
  });

  useEffect(() => {
    valores.ContribuyenteId = contId.ContribuyenteId;
  }, [contId]);

  return (
    
    <Form onSubmit={handleSubmit}>
      <Tab.Container id="tabcontainer" defaultActiveKey="negocioBasico">
        <Row>
          <Col sm={3}>
            <Nav variant="pills" className="flex-column">
              <Nav.Item>
                <Nav.Link eventKey="negocioBasico">Datos Básicos</Nav.Link>
                <Nav.Link eventKey="negocioDireccion">Dirección</Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
          <Col sm={9}>
            <Tab.Content>
              <Tab.Pane eventKey="negocioBasico">
                <Form.Row>
                  <Col sm={8}>
                    <Form.Group>
                      <Form.Label>Contribuyente/Dueño</Form.Label>
                      <Dropdown
                        placeholder="Buscar contribuyente"
                        fluid
                        search
                        selection
                        options={contribuyentes.map((c) => ({
                          key: c.id,
                          value: c.id,
                          text:
                            c.tipopersona === 1
                              ? `${c.nombre} ${c.apellidoPaterno} ${c.apellidoMaterno}`
                              : `${c.razonSocial}`,
                        }))}
                        value={contId.ContribuyenteId}
                        onChange={(e, data) => {
                          setContribuyenteId({
                            ...contId,
                            ContribuyenteId: data.value,
                          });
                        }}
                      />
                    </Form.Group>
                  </Col>

                  <Col>
                    <Form.Group>
                      <Form.Label>Tipo de negocio</Form.Label>
                      <Form.Control
                        as="select"
                        name="tipocomercio"
                        value={tipocomercio}
                        onChange={handleChange}
                      >
                        <option value={0}>Seleccione</option>
                        <option value={parseInt(1)}>
                          Negocio Ambulante/móvil
                        </option>
                        <option value={2}>Local Fijo</option>
                        <option value={3}>Local Semifijo</option>
                      </Form.Control>
                      {errores.tipocomercio && (
                        <Danger
                          variante="danger"
                          mensaje={errores.tipocomercio}
                        />
                      )}
                    </Form.Group>
                  </Col>
                </Form.Row>
                <Form.Row>
                  <Col>
                    <Form.Group>
                      <Form.Label>Nombre/Razón Social</Form.Label>
                      <Form.Control
                        placeholder="Razón social"
                        name="razonsocial"
                        value={razonsocial}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      ></Form.Control>
                    </Form.Group>
                    {errores.razonsocial && (
                      <Danger variante="danger" mensaje={errores.razonsocial} />
                    )}
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label>RFC</Form.Label>
                      <Form.Control
                        placeholder="RFC"
                        name="rfc"
                        value={rfc}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      ></Form.Control>
                    </Form.Group>
                    {errores.rfc && (
                      <Danger variante="danger" mensaje={errores.rfc} />
                    )}
                  </Col>
                </Form.Row>
              </Tab.Pane>
              <Tab.Pane eventKey="negocioDireccion">
                <Direccion
                  nid={nid}
                  setNid={setNid}
                  userid={userid}
                  token={token}
                  tipo={tipo}
                  setTipo={setTipo}
                />
              </Tab.Pane>
              <Col>
                <Button type="submit">Crear</Button>
              </Col>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </Form>
  );
}
export default AgregarNegocio;
